"use strict";
export const escapeRegExp = (string) => {
  if (typeof string == "string") {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  } else {
    return string;
  }
};
